export default __webpack_public_path__ + "images/plot-type-stacked-bar.7dd3107b8fd3e7268326abd0989850f5.svg";